package com.narbase.letsgo.web.models

import com.narbase.letsgo.dto.EnumDtoName

enum class RoutingType(dtoName: String? = null) : EnumDtoName {
    Shortest,
    Fastest
    ;

    override val dtoName = dtoName ?: this.name
}